import { render, staticRenderFns } from "./userlogin.vue?vue&type=template&id=37adfac5&scoped=true&"
import script from "./userlogin.vue?vue&type=script&lang=js&"
export * from "./userlogin.vue?vue&type=script&lang=js&"
import style0 from "./userlogin.vue?vue&type=style&index=0&id=37adfac5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37adfac5",
  null
  
)

export default component.exports